import React from 'react';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
import { Loan, LoanStage } from '../data/mockData';
import { LoanRow } from './LoanRow';
interface StageSectionProps {
  stage: LoanStage;
  loans: Loan[];
  isExpanded: boolean;
  onToggle: () => void;
  onSelectLoan: (loan: Loan) => void;
}
export const StageSection: React.FC<StageSectionProps> = ({
  stage,
  loans,
  isExpanded,
  onToggle,
  onSelectLoan
}) => {
  return <section className="mb-3 bg-white dark:bg-gray-800 rounded-sm shadow-sm border border-[#DCE2EC] dark:border-gray-700 overflow-hidden transition-colors duration-200" data-id="element-168" data-mp="i34wgv99i5dm">
      {/* Section Header */}
      <button onClick={onToggle} aria-expanded={isExpanded} className="w-full flex items-center justify-between px-4 py-3.5 bg-white dark:bg-gray-800 hover:bg-[#F5F8FC] dark:hover:bg-gray-700 transition-colors border-l-4 border-[#0B1856] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#009EDB]" data-id="element-169" data-mp="91etqt9xjk0j">
        <div className="flex items-center gap-3" data-id="element-170" data-mp="3is1fbbivvgmh">
          {isExpanded ? <ChevronDownIcon className="w-4 h-4 text-[#009EDB] transition-colors duration-200" data-id="element-171" data-mp="3nr4foinx4yo4" /> : <ChevronRightIcon className="w-4 h-4 text-[#009EDB] transition-colors duration-200" data-id="element-172" data-mp="39seg8wdmmmwl" />}
          <h3 className="font-bold text-[#0B1856] dark:text-gray-100 text-xs uppercase tracking-[0.12em] transition-colors duration-200" data-id="element-173" data-mp="3epn0d2ic510h">
            {stage}
          </h3>
        </div>
        <div className="flex items-center gap-4" data-id="element-174" data-mp="34t1qa2rgkzps">
          <span className="text-sm font-bold text-[#0B1856] dark:text-gray-300 transition-colors duration-200" data-id="element-175" data-mp="34ulag4g8juwu">
            {new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          }).format(loans.reduce((sum, loan) => sum + loan.amount, 0))}
          </span>
          <span className="min-w-7 bg-[#FF8000] text-white text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-176" data-mp="2m2ae6tg36v7p">
            {loans.length}
          </span>
        </div>
      </button>

      {/* Expanded Content */}
      {isExpanded && <div className="flex flex-col" data-id="element-177" data-mp="mtiqh8mntz4w">
          {loans.length > 0 ? <>
              {/* Mini Table Header */}
              <div className="flex items-center py-2.5 px-4 bg-[#F4F6FA] dark:bg-gray-800/50 border-y border-[#E5EAF2] dark:border-gray-700 text-[10px] font-bold text-[#0B1856]/65 dark:text-gray-400 uppercase tracking-[0.12em] transition-colors duration-200" data-id="element-178" data-mp="dudw8ei4sryj">
                <div className="w-44 flex-shrink-0 pr-4" data-id="element-179" data-mp="16jkudcdobfj9">Borrower</div>
                <div className="w-28 flex-shrink-0 text-right pr-4" data-id="element-180" data-mp="11j6uihm87bwb">Amount</div>
                <div className="w-32 flex-shrink-0 pr-4" data-id="element-181" data-mp="wl5b1vkw1akb">Loan #</div>
                <div className="w-36 flex-shrink-0 pr-4" data-id="element-182" data-mp="wmzmmja9rqbq">Officer</div>
                <div className="flex-1 pr-4" data-id="element-183" data-mp="3mb0aj4tg1ill">Property</div>
                <div className="w-16 flex-shrink-0 text-center pr-4" data-id="element-184" data-mp="3hbdwit5sjybq">Days</div>
                <div className="w-64 flex-shrink-0" data-id="element-185" data-mp="3hdgwo60nr7u6">Alerts</div>
              </div>

              {/* Rows */}
              <div className="flex flex-col" data-id="element-186" data-mp="3c6a7evmb08fs">
                {loans.map((loan, index) => <LoanRow key={loan.id} loan={loan} isStriped={index % 2 !== 0} onSelect={onSelectLoan} data-id="element-187" data-mp="3h5dd8ia3yiot" data-mpi={index} />)}
              </div>
            </> : <div className="py-6 text-center text-sm text-gray-500 dark:text-gray-400 italic border-t border-gray-100 dark:border-gray-700 transition-colors duration-200" data-id="element-188" data-mp="3pxf5vudxquoj">
              No loans currently in this stage.
            </div>}
        </div>}
    </section>;
};